export const KeywordIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M13.4266 10.1703C15.5245 8.07248 15.5245 4.67121 13.4266 2.57337C11.3288 0.475543 7.92751 0.475543 5.8297 2.57337C4.43674 3.96632 3.9687 5.93395 4.42558 7.71307C4.49927 8 4.43383 8.31033 4.22434 8.51986L1.33716 11.407C1.0899 11.6543 0.968431 12.0005 1.00705 12.3481L1.18755 13.9726C1.20679 14.1458 1.2844 14.3072 1.40762 14.4304L1.56956 14.5924C1.69278 14.7156 1.85427 14.7932 2.02745 14.8125L3.65191 14.9929C3.99946 15.0316 4.34572 14.9101 4.59299 14.6628L5.14523 14.1106L5.9702 13.2856L7.48037 11.7754C7.6899 11.5659 8 11.5007 8.28692 11.5744C10.066 12.0313 12.0336 11.5632 13.4266 10.1703ZM8.45562 5.3445C9.06307 4.73702 10.048 4.73702 10.6555 5.3445C11.263 5.95198 11.263 6.93693 10.6555 7.54437C10.048 8.1519 9.06307 8.1519 8.45562 7.54437C7.8481 6.93693 7.8481 5.95198 8.45562 5.3445Z'
        fillRule='evenodd'
        stroke='currentColor'
      />
    </svg>
  )
}
